import React from 'react';
import styled from 'styled-components';
import { AnimatedBackground } from '@@Components/Placeholders/styled';
import { LimitedContainer } from '@@Components/LimitedContainer';
const HomepagePlaceholderWrapper = styled.div ``;
const HomepageBannerPlaceholder = styled(AnimatedBackground) `
    width: 100%;
    height: 450px;
    border-radius: 10px;
`;
const HomepageCorporateLinksPlaceholder = styled.div `
    display: flex;
    flex-flow: row wrap;
    height: 215px;
`;
const HomepageContentPlaceholder = styled.div `
    display: flex;
    flex-flow: row wrap;
    height: 500px;
    ${props => props.margin && `margin: ${props.margin}`};
`;
const HomepageContentBoxPlaceholder = styled(AnimatedBackground) `
    flex-grow: 2;
    margin: ${props => props.margin || '0.5rem .5rem'};
    border-radius: 10px;
`;
export const HomepagePlaceholder = () => {
    return (React.createElement(HomepagePlaceholderWrapper, null,
        React.createElement(HomepageBannerPlaceholder, null),
        React.createElement(LimitedContainer, { wide: true },
            React.createElement(HomepageCorporateLinksPlaceholder, null,
                React.createElement(HomepageContentBoxPlaceholder, null),
                React.createElement(HomepageContentBoxPlaceholder, null),
                React.createElement(HomepageContentBoxPlaceholder, null)),
            React.createElement(HomepageContentPlaceholder, { margin: "2.5rem 0" },
                React.createElement(HomepageContentBoxPlaceholder, null),
                React.createElement(HomepageContentBoxPlaceholder, null)),
            React.createElement(HomepageContentPlaceholder, null,
                React.createElement(HomepageContentBoxPlaceholder, null),
                React.createElement(HomepageContentBoxPlaceholder, null)))));
};
